import 'react-tagsinput/react-tagsinput.css'
import { FC, useState } from 'react'
import TagsInput from 'react-tagsinput'
import { ENTER_KEY_CODE } from 'src/constants/campaigns'
import styles from './chipsInput.module.scss'

const COMMA_KEY_CODE = 188
const TAB_KEY_CODE = 9

interface ChipsInputProps {
  emptyPlaceholder: string
  id?: string
  maxChips?: number
  onChange: (value: string[]) => void
  value: string[]
}

const dedupe = (values: string[]): string[] => {
  const seen = new Set<string>()
  return values
    .map((value) => value.trim())
    .filter((value) => {
      const key = value.toLowerCase()
      if (!value || seen.has(key)) return false
      seen.add(key)
      return true
    })
}

// Names as removable chips: Enter, comma or Tab adds the typed text, and so
// does leaving the field, so a name typed but not "added" is never lost.
export const ChipsInput: FC<ChipsInputProps> = ({
  emptyPlaceholder,
  id,
  maxChips,
  onChange,
  value,
}) => {
  const [input, setInput] = useState('')

  return (
    <div className={styles.chips}>
      <TagsInput
        addKeys={[ENTER_KEY_CODE, COMMA_KEY_CODE, TAB_KEY_CODE]}
        addOnBlur
        inputProps={{
          className: 'chips-input',
          id,
          placeholder: value.length ? 'Add another' : emptyPlaceholder,
        }}
        inputValue={input}
        maxTags={maxChips}
        onChange={(tags: string[]) => {
          onChange(dedupe(tags))
          setInput('')
        }}
        onChangeInput={setInput}
        value={value}
      />
    </div>
  )
}
